import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { FunctionParametersSettingClockWeekWpComponent } from '../../../Component/function-parameters-setting-clock-week-wp/function-parameters-setting-clock-week-wp.component';
import { FunctionParametersSettingsClockWpComponent } from '../../../Component/function-parameters-settings-clock-wp/function-parameters-settings-clock-wp.component';

@Component({
  selector: 'app-p00061-chauffage-mise-en-oeuvre-programmation',
  templateUrl: './p00061-chauffage-mise-en-oeuvre-programmation.component.html',
  styleUrls: ['./p00061-chauffage-mise-en-oeuvre-programmation.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
  ],
})
export class P00061ChauffageMiseEnOeuvreProgrammationComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockWpComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('wpPHorlogeJourLundi'),
          this.actionStack!.getValue('wpPHorlogeJourMardi'),
          this.actionStack!.getValue('wpPHorlogeJourMercredi'),
          this.actionStack!.getValue('wpPHorlogeJourJeudi'),
          this.actionStack!.getValue('wpPHorlogeJourVendredi'),
          this.actionStack!.getValue('wpPHorlogeJourSamedi'),
          this.actionStack!.getValue('wpPHorlogeJourDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage3,
        'wpPHorlogeJourLundi',
        hj[0],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage4,
        'wpPHorlogeJourMardi',
        hj[1],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage5,
        'wpPHorlogeJourMercredi',
        hj[2],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage6,
        'wpPHorlogeJourJeudi',
        hj[3],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage7,
        'wpPHorlogeJourVendredi',
        hj[4],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage8,
        'wpPHorlogeJourSamedi',
        hj[5],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage9,
        'wpPHorlogeJourDimanche',
        hj[6],
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekWpComponent,
      componentProps: {
        value: this.actionStack!.getValue('wpPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACWP_Parametrage2,
        'wpPHorlogeSemaine',
        hj,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
